export default __webpack_public_path__ + "static/cognizant_1-8db0ecac8f6fb8af3f9d5a7ee135152b.jpeg";